import { ReactNode } from 'react';

import { createPortal } from 'react-dom';

type PortalProps = {
  children: ReactNode;
};

const PORTAL_CONTAINER_ID = 'ksai-portal-root';

export function Portal({ children }: PortalProps) {
  const container = typeof document === 'undefined' ? null : document.getElementById(PORTAL_CONTAINER_ID);

  if (!container) return null; // no portal root yet
  return createPortal(children, container);
}
